import React, { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
// import FinxPay from "../../assests/images/logo.png";
import paytomLogo from "../../assests/images/logo.png";
import klikpayLogo from "../../assests/images/klikpaylogo.png";
import QRBonPayLogo from "../../assests/images/banqo.jpg";
import leopaylogo from "../../assests/images/leopay.jpg";
import "./login.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import TextField from "../../Helper/TextField";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { AUTH_LOGIN } from "../../redux/auth/types";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { klikpayTitle } from "../../utils/comman/Common";
import { getLocationAndip } from "../../redux/IpAndLocation/action";
import axios from "axios";
import { LEOPAY_TITLE_NAME, serviceId } from "../../utils/Constant";
import axiosinstances from "../../Helper/useAxios";
import { getConfigdetails } from "../../redux/config/action";

const Login = () => {
  const title = process.env.REACT_APP_TITLE;
  const getUniqId = () => {
    const uuid = uuidv4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const loginLoding = useSelector((state) => state?.authReducer?.loading);
  const primaryColor =
    title === "KlikPay Merchant Portal"
      ? process.env.REACT_APP_PRIMARY_COLOR_KLIKPAY
      : title === "QRBonPay Merchant Portal"
      ? process.env.REACT_APP_PRIMARY_COLOR_QRBonPay
      : title === LEOPAY_TITLE_NAME
      ? process.env.REACT_APP_PRIMARY_COLOR_leopay
      : process.env.REACT_APP_PRIMARY_COLOR_PAYTOM;
  const unique_id = getUniqId();
  const logo =
    title === "KlikPay Merchant Portal"
      ? klikpayLogo
      : title === "QRBonPay Merchant Portal"
      ? QRBonPayLogo
      : title == LEOPAY_TITLE_NAME
      ? leopaylogo
      : paytomLogo;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fetchIP = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      dispatch(getLocationAndip({ ip: response.data.ip }));
    } catch (error) {
      console.error("Error fetching IP:", error);
    }
  };
  const fetchConfigDetails = async () => {
    let url = `/api/v1/upi/config/get/${serviceId}`;
    await axiosInstance
      .get(url, {
        // headers,
      })
      .then((res) => {
        dispatch(getConfigdetails(res.data));
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };
  useEffect(() => {
    fetchConfigDetails();
    fetchIP();
  }, []);
  console.log(
    "logo and tital",
    title,
    LEOPAY_TITLE_NAME,
    title == LEOPAY_TITLE_NAME
  );
  const validate = Yup.object({
    id: Yup.string()
      // .matches(numberregex, 'only number is allowed')
      .min(10, "Min value 10.")
      .required("User Id Is Required"),
    password: Yup.string()
      // .matches(passregex, 'only number is allowed')
      .min(4, "Password Must Be Atleast 4 Characters")
      .required("Password Is Required"),
  });

  const onSubmitLogin = (values) => {
    console.log("calling");
    dispatch({
      type: AUTH_LOGIN,
      payload: { values, unique_id, navigate, dispatch, userIp },
    });
  };
  return (
    <div className="login-container">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
            <div className="login-box">
              <div className="login-head">
                {/* {title !== LEOPAY_TITLE_NAME && ( */}
                <img
                  style={{ borderRadius: "20px", backgroundColor: "#333333" }}
                  src={logo}
                  alt="logo"
                  className="img-fluid"
                />
                {/* )} */}

                <h3
                  style={{
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  Welcome To Merchant Portal
                </h3>
                {/* <p>Login To Continue</p> */}
              </div>

              <Formik
                initialValues={{
                  id: "",
                  password: "",
                }}
                validationSchema={validate}
                onSubmit={(values) => {
                  onSubmitLogin(values);
                }}
              >
                {(formik) => (
                  <>
                    <div className="login-form">
                      <Form>
                        <div className=" form-floating">
                          <TextField
                            placeholder="User ID"
                            label="User ID"
                            name="id"
                            type="id"
                          />
                        </div>
                        <div className=" form-floating">
                          <TextField
                            name="password"
                            label="Password"
                            type="password"
                            placeholder="Your Password"
                          />
                        </div>
                        {loginLoding ? (
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <button
                            disabled={loginLoding}
                            style={{ backgroundColor: primaryColor }}
                            className="btn btn-primary"
                            type="submit"
                          >
                            Login Now
                          </button>
                        )}
                      </Form>

                      {/* <p>
                        <a href="#">Forgot password?</a>
                      </p> */}
                    </div>
                    <ToastContainer />
                  </>
                )}
              </Formik>
            </div>
          </div>

          {/* <div className="col-12">
            <div className="logcopy">
              Copyright &copy; 2022 All rights reserved. <br />
              Powered by Uvva Infotech Pvt. Ltd.
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
